// extracted by mini-css-extract-plugin
export var active = "cameraComparison-module--active--8c112";
export var backToTopBtn = "cameraComparison-module--backToTopBtn--73a8c";
export var cameraComparisonContainer = "cameraComparison-module--cameraComparisonContainer--22d54";
export var cameraComparisonWrapper = "cameraComparison-module--cameraComparisonWrapper--5f04b";
export var fadeInButtons = "cameraComparison-module--fadeInButtons--02546";
export var fixedOverlay = "cameraComparison-module--fixedOverlay--c691f";
export var hideWrapper = "cameraComparison-module--hideWrapper--a159e";
export var show = "cameraComparison-module--show--3eb9f";
export var showWrapper = "cameraComparison-module--showWrapper--2fd80";
export var slideDown = "cameraComparison-module--slideDown--17000";
export var slideTop = "cameraComparison-module--slideTop--44e86";
export var slideUp = "cameraComparison-module--slideUp--29872";